import { render, staticRenderFns } from "./FieldIconSelector.vue?vue&type=template&id=16452c50&"
import script from "./FieldIconSelector.vue?vue&type=script&lang=js&"
export * from "./FieldIconSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports